import GridPage from "components/layout/GridPage";
import { Box, Typography, Button } from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useIsMobile from "components/hooks/useIsMobile";
import { ClipboardList } from "lucide-react";
import FlexBox from "components/common/FlexBox";
import { useListAgentPrompts } from "services/agents";
import {
  AgentPrompt,
  ListAgentPromptsRequest,
} from "protogen/agents_service_pb";
import PlaybookCard from "components/tools/PlaybookCard";

export default () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const [playbooks, setPlaybooks] = useState<AgentPrompt[]>([]);

  const { request: listAgentPrompts } = useListAgentPrompts();

  useEffect(() => {
    loadPlaybooks();
  }, []);

  const loadPlaybooks = async () => {
    const response = await listAgentPrompts(
      new ListAgentPromptsRequest({ type: "playbook" }),
    );
    if (response) {
      setPlaybooks(response.prompts);
    }
  };

  const handleCreatePlaybook = () => {
    navigate("/tools/agents/playbooks/new");
  };

  return (
    <GridPage
      sx={{
        margin: isMobile ? "" : "64px auto",
        maxWidth: "800px",
        padding: isMobile ? "20px" : "0",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-between",
          alignItems: isMobile ? "flex-start" : "center",
          marginBottom: "24px",
          gap: "12px",
        }}
      >
        <FlexBox direction="column" gap="8px">
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <ClipboardList
              color="#198282"
              height="24px"
              width="24px"
              style={{ marginRight: "8px" }}
            />
            <Typography variant="title">Playbooks</Typography>
          </Box>
          <Typography variant="body">
            Repeatable, customizable playbooks that can be followed in any task.
          </Typography>
        </FlexBox>
        <Button onClick={handleCreatePlaybook} variant="outlined" sx={{}}>
          Add playbook
        </Button>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "0",
          border: "1px solid #EAEBEC",
          borderRadius: "8px",
          background: "#FFF",
        }}
      >
        {playbooks.length === 0 ? (
          <Box sx={{ padding: "40px 24px", textAlign: "center" }}>
            <Typography variant="body" color="#667085">
              No playbooks yet. Click "Add playbook" to create your first one.
            </Typography>
          </Box>
        ) : (
          <Box sx={{ padding: "0" }}>
            {playbooks.map((playbook, index) => (
              <Box key={playbook.ref}>
                {index > 0 && <Box sx={{ borderTop: "1px solid #EAEBEC" }} />}
                <PlaybookCard
                  playbook={playbook}
                  onUpdate={loadPlaybooks}
                  isLast={index === playbooks.length - 1}
                  isFirst={index === 0}
                />
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </GridPage>
  );
};
